export default __webpack_public_path__ + "static/media/210.c5dbdb46.png";